export const environment = {
  id: 'development',
  AUTH_CONFIG: {
    HOST: 'https://auth.proficloud-dev.io/auth',
    REALM: 'kaa',
    CLIENT_ID: 'chargerepay-manager-frontend',
    REDIRECT_URI: '/',
  },
  chargeRepayBaseURL: 'https://backend.charge-repay-development.de/charge-repay-service',
  chargeRepayInstallMgrURL:
    'https://backend.charge-repay-development.de/charge-repay-installation-manager',
  chargeRepayLogoutTime: 5,
  chargesPollingInterval: 5000,
  connectionStatePollingInterval: 60000,

  contactEmail: 'charge-repay@phoenixcontact-sb.io',
  contactLink: 'https://charge-repay.io/kontakt',
  copyright: '2026 © Proficloud.io | All rights reserved',
  dataPrivacyLink: 'https://www.phoenixcontact.com/de-de/rechtliche-hinweise/datenschutz',
  softwareLicenceTerm: 'https://charge-repay.io/downloads/SLT_May_2018.pdf',
  termsAndCondition: 'https://charge-repay.io/downloads/GTC_October_2020.pdf',
  siteNoticeLink: 'https://proficloud.io/site-notice',

  pcIAMBaseURL: 'https://env.kaa.proficloud-development.io/middleware/iam',

  production: false,

  I18N_CONFIG: {
    supportedLocales: ['de-DE', 'en-GB'],
    defaultLocale: 'en-GB',
    appLocale: 'de-DE',
  },
  passwordRegex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@$!%*?&#])[A-Za-z0-9@$!%*?&#]{10,}$/,

  appIdentifier: 'MANAGER',
  wattson: true,
  wattsonEndpointUrl:
    'https://endpoint-app.cognigy.ai/c45e6e23121ea353443ab0c25503cd1ba058aa1379f2ae092c8d24ae6b204da7',
  wattsonEndpointKey: '3302cbecc311e627e4afb6212078a268e99170fb5df124c3f7086e3486b53352',
};
